module.exports = __webpack_public_path__ + "static/img/stab_450.24b968e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/stab_450.jpg
// module id = nWwV
// module chunks = 0